'use client';

import { c as _c } from "react/compiler-runtime";
import type { ActivityService, UpdateCheckoutExtraInput } from '@funkey/types/graphql/graphql';
import { Checkbox, FormGroup, FormInputErrors, FormLabel, Textarea } from '~/components/primitives';
import { CheckoutCateringFields } from './CheckoutCateringFieldset';
import type { FormState } from '~/modules/form';
import type { I18n } from '@funkey/locales';
import React from 'react';
import Title from '~/components/utils/Title';
import { cx } from 'class-variance-authority';
import { std } from '@funkey/shared/utils';
import { useI18n } from '~/features/i18n';
import { usePortalCtx } from '~/features/global/portal';
import { useShouldDisplayPrices } from '~/features/portals/money';
export default function CheckoutExtraPageForm(t0) {
  const $ = _c(34);
  const {
    formState,
    isFetchingServices,
    services,
    participants
  } = t0;
  const {
    getNativeInputProps,
    getErrorMessages
  } = formState;
  const i18n = useI18n();
  const portal = usePortalCtx();
  const isCateringVisible = portal.portal !== "BIZZ" || !portal.bizz.disableCatering;
  let t1;
  if ($[0] !== formState || $[1] !== i18n || $[2] !== isCateringVisible || $[3] !== participants) {
    t1 = isCateringVisible && <CheckoutCateringFields.Component i18n={i18n} formState={formState.$subform()} participants={participants} />;
    $[0] = formState;
    $[1] = i18n;
    $[2] = isCateringVisible;
    $[3] = participants;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== formState || $[6] !== i18n || $[7] !== isFetchingServices || $[8] !== portal.bizz || $[9] !== portal.portal || $[10] !== services) {
    t2 = (portal.portal !== "BIZZ" || !portal.bizz.disableServices) && <Services i18n={i18n} formState={formState} isFetching={isFetchingServices} services={services} />;
    $[5] = formState;
    $[6] = i18n;
    $[7] = isFetchingServices;
    $[8] = portal.bizz;
    $[9] = portal.portal;
    $[10] = services;
    $[11] = t2;
  } else {
    t2 = $[11];
  }
  let t3;
  if ($[12] !== i18n) {
    t3 = i18n._("Remarks or questions");
    $[12] = i18n;
    $[13] = t3;
  } else {
    t3 = $[13];
  }
  let t4;
  if ($[14] !== t3) {
    t4 = <Title as="h3" size="xl" weight="bold" className="mb-6">{t3}</Title>;
    $[14] = t3;
    $[15] = t4;
  } else {
    t4 = $[15];
  }
  let t5;
  if ($[16] !== getNativeInputProps) {
    t5 = getNativeInputProps("remarks");
    $[16] = getNativeInputProps;
    $[17] = t5;
  } else {
    t5 = $[17];
  }
  let t6;
  if ($[18] !== t5) {
    t6 = <Textarea id="remarks" rows={6} className="resize-none px-6 py-4" {...t5} />;
    $[18] = t5;
    $[19] = t6;
  } else {
    t6 = $[19];
  }
  let t7;
  if ($[20] !== getErrorMessages) {
    t7 = getErrorMessages("remarks");
    $[20] = getErrorMessages;
    $[21] = t7;
  } else {
    t7 = $[21];
  }
  let t8;
  if ($[22] !== t7) {
    t8 = <FormInputErrors errors={t7} />;
    $[22] = t7;
    $[23] = t8;
  } else {
    t8 = $[23];
  }
  let t9;
  if ($[24] !== t6 || $[25] !== t8) {
    t9 = <FormGroup htmlFor="remarks">{t6}{t8}</FormGroup>;
    $[24] = t6;
    $[25] = t8;
    $[26] = t9;
  } else {
    t9 = $[26];
  }
  let t10;
  if ($[27] !== t4 || $[28] !== t9) {
    t10 = <fieldset>{t4}{t9}</fieldset>;
    $[27] = t4;
    $[28] = t9;
    $[29] = t10;
  } else {
    t10 = $[29];
  }
  let t11;
  if ($[30] !== t1 || $[31] !== t10 || $[32] !== t2) {
    t11 = <div className="space-y-10" data-testid="checkout-extra-form">{t1}{t2}{t10}</div>;
    $[30] = t1;
    $[31] = t10;
    $[32] = t2;
    $[33] = t11;
  } else {
    t11 = $[33];
  }
  return t11;
}

// const Coordination = ({
//     i18n,
//     formState,
// }: {
//     i18n: I18n;
//     formState: FormState<UpdateCheckoutExtraInput>;
// }) => (
//     <>
//         <Title as="h3" className="mb-6" size="xl" weight="bold">
//             {i18n._('Coordination')}
//         </Title>
//
//         <div
//             className={`relative mb-10 flex items-center justify-between gap-3 rounded-2xl border p-6 sm:rounded-4xl sm:py-3 sm:pl-10 sm:pr-3 ${
//                 formState.values.hasCoordination
//                     ? 'border-2 border-secondary'
//                     : 'border-blue-200'
//             }`}
//         >
//             <div className="flex flex-row gap-3">
//                 <Checkbox
//                     id="hasCoordination"
//                     checked={formState.values.hasCoordination}
//                     onChange={() =>
//                         formState.handleChange('hasCoordination', !formState.values.hasCoordination)
//                     }
//                 />
//
//                 <div>
//                     <FormLabel
//                         label={i18n._('I want Funkey to take care of the coordination')}
//                         htmlFor="hasCoordination"
//                         className="max-w-[calc(100%-50px)]"
//                     />
//                     <p className="mt-1 text-sm text-blue-500">
//                         {i18n._('checkout.extra.coordination.description')}
//                     </p>
//                 </div>
//             </div>
//             <div className="relative hidden h-40 w-60 shrink-0 rounded-3xl bg-gray-200 sm:block">
//                 <Image
//                     src={COORDINATION_IMAGE}
//                     alt="coordination-image"
//                     fill
//                     className="rounded-3xl"
//                 />
//             </div>
//             <div className="absolute -right-px -top-px rounded-bl-3xl rounded-tr-2xl bg-secondary px-3 py-2.5 text-sm font-medium text-white sm:rounded-bl-3xl sm:rounded-tr-3xl sm:p-5 sm:text-base">
//                 {i18n._('Popular')}
//             </div>
//         </div>
//     </>
// );

const Services = t0 => {
  const $ = _c(35);
  const {
    i18n,
    formState,
    isFetching,
    services
  } = t0;
  const {
    serviceIds
  } = formState.values;
  const shouldDisplayPrices = useShouldDisplayPrices();
  let t1;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  if ($[0] !== formState || $[1] !== i18n || $[2] !== isFetching || $[3] !== serviceIds || $[4] !== services || $[5] !== shouldDisplayPrices) {
    t6 = Symbol.for("react.early_return_sentinel");
    bb0: {
      const filteredServices = services?.filter(_temp) ?? [];
      let t7;
      if ($[12] !== formState) {
        t7 = serviceId => {
          formState.handleChange("serviceIds", std.Array.toggle(formState.values.serviceIds, serviceId));
        };
        $[12] = formState;
        $[13] = t7;
      } else {
        t7 = $[13];
      }
      const handleServiceSelection = t7;
      if (isFetching) {
        let t8;
        if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
          t8 = <div className="mb-10"> Loading...</div>;
          $[14] = t8;
        } else {
          t8 = $[14];
        }
        t6 = t8;
        break bb0;
      }
      let t8;
      if ($[15] !== i18n) {
        t8 = i18n._("Extra services");
        $[15] = i18n;
        $[16] = t8;
      } else {
        t8 = $[16];
      }
      if ($[17] !== t8) {
        t3 = <Title as="h3" size="xl" weight="bold" className="mb-6">{t8}</Title>;
        $[17] = t8;
        $[18] = t3;
      } else {
        t3 = $[18];
      }
      let t9;
      if ($[19] !== i18n) {
        t9 = i18n._("checkout.extra.services.description");
        $[19] = i18n;
        $[20] = t9;
      } else {
        t9 = $[20];
      }
      if ($[21] !== t9) {
        t4 = <p className="mb-8 text-sm text-blue-500">{t9}</p>;
        $[21] = t9;
        $[22] = t4;
      } else {
        t4 = $[22];
      }
      let t10;
      if ($[23] !== formState) {
        t10 = formState.getErrorMessages("serviceIds");
        $[23] = formState;
        $[24] = t10;
      } else {
        t10 = $[24];
      }
      if ($[25] !== t10) {
        t5 = <FormInputErrors errors={t10} />;
        $[25] = t10;
        $[26] = t5;
      } else {
        t5 = $[26];
      }
      t1 = "rounded-2xl sm:rounded-4xl";
      t2 = filteredServices && filteredServices?.length > 0 && filteredServices.map((item, index) => {
        const isSelected = serviceIds?.includes(item.id);
        return <div key={item.id} className={cx("relative cursor-pointer transition-all duration-200", "z-0 -mb-[2px] flex flex-col gap-4 border-2 px-6 py-8 last:mb-0 hover:z-2", isSelected ? "border-secondary bg-secondary-50" : "border-blue-200 hover:border-blue-400 hover:bg-blue-50", {
          "rounded-t-2xl sm:rounded-t-4xl": index === 0,
          "rounded-b-2xl sm:rounded-b-4xl": index === filteredServices.length - 1
        }, isSelected && "z-1")} onClick={event => {
          const target = event.target as HTMLElement;
          if (target.tagName === "INPUT" || target.tagName === "LABEL" || target.tagName === "TEXTAREA" || target.closest("textarea")) {
            return;
          }
          handleServiceSelection(item.id);
        }} role="button" tabIndex={0}><div className="items-top flex gap-3"><div className="service-checkbox select-none"><Checkbox id={`service-${item.id}`} checked={isSelected} value={item.id} onChange={() => handleServiceSelection(item.id)} /></div><div className="mt-[-3px] flex w-full select-none flex-col gap-2"><FormLabel size="md" label={item.name} htmlFor={`service-${item.id}`} /><div className="flex flex-col justify-between gap-3 md:flex-row"><span className="text-sm text-blue-500">{item.description}</span>{shouldDisplayPrices && !!item?.priceMin && <span className="whitespace-nowrap text-blue-400">{formatPrice(i18n, item.priceMin, item.priceMax, false)}</span>}</div></div></div></div>;
      });
    }
    $[0] = formState;
    $[1] = i18n;
    $[2] = isFetching;
    $[3] = serviceIds;
    $[4] = services;
    $[5] = shouldDisplayPrices;
    $[6] = t1;
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
    $[10] = t5;
    $[11] = t6;
  } else {
    t1 = $[6];
    t2 = $[7];
    t3 = $[8];
    t4 = $[9];
    t5 = $[10];
    t6 = $[11];
  }
  if (t6 !== Symbol.for("react.early_return_sentinel")) {
    return t6;
  }
  let t7;
  if ($[27] !== t1 || $[28] !== t2) {
    t7 = <div className={t1}>{t2}</div>;
    $[27] = t1;
    $[28] = t2;
    $[29] = t7;
  } else {
    t7 = $[29];
  }
  let t8;
  if ($[30] !== t3 || $[31] !== t4 || $[32] !== t5 || $[33] !== t7) {
    t8 = <fieldset>{t3}{t4}{t5}{t7}</fieldset>;
    $[30] = t3;
    $[31] = t4;
    $[32] = t5;
    $[33] = t7;
    $[34] = t8;
  } else {
    t8 = $[34];
  }
  return t8;
};
const formatPrice = (i18n: I18n, min?: number | null, max?: number | null, pricePerPerson: boolean = true) => {
  if (min === null && max === null) return null;
  if (min === max) return `${i18n._('from')} €${min} ${pricePerPerson ? i18n._('p.p.') : ''}`;
  if (!max) return `€${min} ${pricePerPerson ? i18n._('p.p.') : ''}`;
  return `€${min} - €${max} ${pricePerPerson ? i18n._('p.p.') : ''}`;
};
function _temp(s) {
  return [6, 7].includes(s.id);
}